import { IRequestConfig } from "angular";

import { IStatsItem } from "./models";

// Parses a header value in the form of
// key1=value1, key2=value2,key3=value3
// into an object
// { key1: value1, key2: value2, key3: value3 }
const parseHeader = (value: string): Record<string, string> =>
  value
    .split(/,\s*/g)
    .map((x) => {
      const y = x.split("=");
      return { [y[0]]: y[1] };
    })
    .reduce((result, x) => ({ ...result, ...x }), {});

export const generateStatsItem = (jaegerBaggage: string, jaegerBaggageScreen: string, config: IRequestConfig): IStatsItem => {
  const jaegerBaggageRecord = parseHeader(jaegerBaggage);
  const jaegerBaggageScreenRecord = parseHeader(jaegerBaggageScreen);

  return {
    sessionID: jaegerBaggageRecord.sessionID || "null",
    screenID: jaegerBaggageScreenRecord.screenID || "null",
    screenName: jaegerBaggageScreenRecord.screenName || "null",
    actionID: jaegerBaggageRecord.actionID || "null",
    actionName: jaegerBaggageRecord.actionName || "null",
    url: config.url,
    method: config.method,
  };
};
